const dec2hex = (dec: number): string => dec.toString(16).padStart(2, '0');

/**
 * Генерирует короткий DOM/CSS-безопасный случайный id.
 *
 * Так же (8 hex-символов из случайных байт) `@cian/mf-registry` генерирует `instance.id`.
 * Нельзя брать React `useId()`: независимые React-корни разных сервисов на одной
 * странице выдают одинаковые `:r0:`-идентификаторы.
 */
export const generateRandomString = (length = 8): string => {
  const randomArray = new Uint8Array(length / 2);

  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(randomArray);
  } else {
    randomArray.forEach((_, index) => {
      randomArray[index] = Math.floor(Math.random() * 256);
    });
  }

  return Array.from(randomArray, dec2hex).join('');
};
